<div class="site-wrap jq-site-wrap">
  <div class="header-sa float-start w-100 bg-white">
    <div class="metrium float-start">
      <a
        href="javascript:;"
        routerLink="/home"
        routerLinkActive="active"
        class="menu-click"
      >
        <img src="../../../assets/images/logo.png" alt="Logo" class="logo-lg" />
      </a>
    </div>
    <div class="menu-icon-wrap jq-menu-icon-wrap" id="menu">
      <span class="menu-icon"></span>
    </div>
    <div class="float-end">
      <div class="dropdown">
        <div class="user-img">
          <img
            id="imgProfileImage"
            [src]="
              userInfo.profile_pic != ''
                ? userInfo.profile_pic
                : '../../../assets/images/user-lg.jpg'
            "
            alt=""
          />
        </div>
        <a
          class="dropdown-toggle text-decoration-none grey-text"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          >{{ userInfo.full_name }}</a
        >
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <li>
            <a class="dropdown-item" routerLink="/profile"
              ><i class="far fa-user me-2"></i>Profile</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              href="javascript:;"
              (click)="logOut(userInfo.id.toString())"
              ><i class="fas fa-sign-out-alt me-2"></i>Logout</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <aside class="sidebar-sa sidebar_large">
    <!--Loading Admin Menu-->
    <ng-container *ngIf="role === roleEnum.MasterAdmin">
      <app-master-admin-menu></app-master-admin-menu>
    </ng-container>
    <ng-container *ngIf="role !== roleEnum.MasterAdmin">
      <admin-menu></admin-menu>
    </ng-container>
  </aside>

  <main class="main-content-sa">
    <div class="content-wraper">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
